export default function donationRadio(el: HTMLElement) {
    const radioOptions = el.querySelectorAll<HTMLInputElement>("input[type=radio]");
    const customAmount = el.querySelector<HTMLInputElement>("[data-custom-donation-amount]");

    function updateSelectedRadioOption() {
        const value = customAmount?.value;
        for (const opt of radioOptions) {
            opt.checked = opt.value == value;
        }
    }

    customAmount?.addEventListener("input", updateSelectedRadioOption);

    for (const opt of radioOptions) {
        opt.addEventListener("input", (ev) => {
            if (opt.checked) {
                customAmount!.value = "";
            }
        })
    }

    if (customAmount?.value) {
        updateSelectedRadioOption();
    }
}
